/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![WebhookIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAACUklEQVR4nM2VO2sUURTHI9ql8v3CUvQLWMoKuhgzcx4TuXvO6NrZKL4fIYViISq29lrZWCqC4muJIvgRbHU3KgEN+ECNuMqZubOZrNlNmNnCgVvs3Dv/37n/89ihof/hCVn2Acl9JPluC1gniWIYiDiQXEbWNrL+6VptILlYLnKK2Yv9AtJxAF2PqJuQZQJIZm2PSHYVj5510kRMHFERWVtA0kwt0/EETvK0MABZvyUAi5z0fc6eN6PObfDwLyUA8sFERpxbmwcAybtkn+QFsD4vDACWhyYYkpwDFjJhD/hdyvvsCUl2ext+AulZ59xyZL3kIc0gOLCyNARZr3SsYTlSqVRWAMur9LfeKg0IArc5aTDWdhjVdiRQdNuyAggp3l8KACQ3fTneyb/HSE+k73XaqqyQeDgWb0+bTGaDsXhr1/YyJHngrbu7JEGi2l6rHCC9nUTPci/1X24sfF62AMuMP/MVWBvWkAuK21yZS6a+JpKdWSP1swBYa8j6Y96cIrk67xBibU9Wjoh6ulqtDwPrS//BhaXcPorq65J+6cyo3LRFkkcecMquCCxTWcdWq/XhfsLAEvoGbJmo9Yt34VkOoNPZSMjEiyxgmXLOrfKAz3MAlk+DACBrqwMg/ZhPVCM3c+zKTWB9SxSPLuY9RhpYUOk3EiLLyX/GuJ/1aZJZzkfRwY22PHAGWI51CxPFhy1iZDnDfGh1GMZrLIepRleSvU3Xe3pLerwbEFJ8tM/5a70qgiz7Samlf+6PIdKRXvaYhcj6xM4ni7VhGovZOtDnLza2ryeCedJkAAAAAElFTkSuQmCC)
 */
export const WebhookIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="m7.7 16.95 3.68-6.76a1 1 0 0 0-.5-1.4A3 3 0 1 1 15 6a1 1 0 1 0 2 0 5 5 0 1 0-7.85 4.1L5.95 16a2 2 0 1 0 1.78 3h8.54a2 2 0 1 0 0-2H7.73l-.02-.05Z"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M13.8 6.86A2 2 0 1 0 12.16 8l4.53 6.58a1 1 0 0 0 .82.43h.5a3 3 0 1 1-1.98 5.25 1 1 0 0 0-.66-.25h-.01a1 1 0 0 0-.66 1.75A4.98 4.98 0 0 0 23 18a5 5 0 0 0-4.97-5L13.8 6.86ZM5.97 13.88a1 1 0 0 1-.72 1.21 3 3 0 1 0 2.73 5.16 1 1 0 1 1 1.33 1.5A4.98 4.98 0 0 1 1 18a5 5 0 0 1 3.75-4.84 1 1 0 0 1 1.22.72Z"
        className={colorClass}
      />
    </svg>
  );
};
